<template>
  <!-- detail delivery orders -->
  <div class="w-full">
    <vs-table
      :style="{ width: '100%' }"
      :sst="false"
      :data="dataViews"
      :total="dataViews.length"
      :searchable="false"
    >
      <template slot="thead">
        <vs-th v-if="!isNew">Delivery Plan Code</vs-th>
        <vs-th>Delivery Order Code</vs-th>
        <vs-th>Customer Data</vs-th>
        <vs-th v-if="!isNew">Request Delivery Date</vs-th>
        <vs-th v-if="!isNew">Weight</vs-th>
        <vs-th v-if="!isNew">Volume</vs-th>
        <vs-th>Warehouse</vs-th>
        <vs-th>Zone</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr 
          :data="tk" 
          :key="indextr" 
          v-for="(tk, indextr) in data"
          :class="{ 'cancel-row': isProcessingCancel(tk.status) }"
        >
          <vs-td v-if="!isNew">
            {{ tk.delivery_plan_code }}
          </vs-td>
          <vs-td>
            <div class="do-code-wrapper">
              <span>{{ tk.delivery_order_code }}</span>
              <strong v-if="isProcessingCancel(tk.status)" class="cancel-flag">
                Cancel
              </strong>
            </div>
          </vs-td>
          <vs-td>
            <ul>
              <li>
                <strong>Customer Code:</strong>
                {{ tk.customer_code }}
              </li>
              <li>
                <strong>Customer Name:</strong>
                {{ tk.customer_name }}
              </li>
              <li>
                <strong>Customer Address:</strong>
                {{ tk.customer_address }}
              </li>
            </ul>
          </vs-td>
          <vs-td v-if="!isNew">
            {{ tk.request_delivery_date }}
          </vs-td>

          <vs-td v-if="!isNew">
            {{ tk.weight }}
          </vs-td>
          <vs-td v-if="!isNew">
            {{ tk.volume }}
          </vs-td>
          <vs-td>
            {{ tk.warehouse_name }}
          </vs-td>
          <vs-td>
            {{ tk.zone_name }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  props: {
    dataViews: {
      type: Array,
      default: () => [],
    },
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isProcessingCancel(status) {
      return status === 98 || status === 99;
    },
  },
};
</script>
<style scoped>
.vl {
  border-left: 6px solid black;
  height: 100%;
}

/* Cancel row styling with attractive highlight */
.cancel-row {
  background-color: #fff5f5 !important;
  border-left: 4px solid #e53e3e !important;
  transition: all 0.3s ease;
}

.cancel-row:hover {
  background-color: #fed7d7 !important;
  box-shadow: 0 2px 8px rgba(229, 62, 62, 0.15);
}

/* DO Code wrapper */
.do-code-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Cancel flag styling */
.cancel-flag {
  color: #e53e3e;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  animation: pulse-subtle 2s ease-in-out infinite;
}

/* Pulse animation for cancel flag */
@keyframes pulse-subtle {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.75;
  }
}
</style>
